<template>
    <div class="question mb-4">
        <div class="mb-3">
            <div class="question__title">В приведенной ниже таблице отметьте, каким именно навыкам осуществлялось обучение в Вашей организации за последние 12 месяцев.
            </div>
            <div class="question__desc caption">Укажите примерное количество человек, которое обучалось навыку по решению Вашей организации.</div>
        </div>

        <table class="table-skills">
            <thead class="table-skills__header">
                <tr>
                    <td rowspan="2">Наименование навыков</td>
                    <td colspan="3">Количество сотрудников, прошедших обучение данному навыку на Вашем предприятии</td>
                </tr>
                <tr>
                    <td>Менеджеры и руководители</td>
                    <td>Специалисты и инженеры</td>
                    <td>Рабочий персонал</td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(id, index) in ids" v-if="index%3 === 0" :key="id">
                    <td v-if="list[id].text">{{ list[id].text }}</td>
                    <td>
                        <question-input
                                v-if="list[ids[index]].type === 'input'"
                                @input="$emit('sendAnswer', $event, ids[index])"
                        />
                    </td>
                    <td>
                        <question-input
                                v-if="list[ids[index + 1]].type === 'input'"
                                @input="$emit('sendAnswer', $event, ids[index + 1])"
                        />
                    </td>
                    <td>
                        <question-input
                                v-if="list[ids[index + 2]].type === 'input'"
                                @input="$emit('sendAnswer', $event, ids[index + 2])"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import QuestionInput from '@/components/question/input'

    export default {
        components: {
            QuestionInput
        },
        props: {
            ids: Array
        },
        data () {
            return {
                items: [],
                value: ''
            }
        },
        computed: {
            ...mapGetters('questions', ['questions']),
            list () {
                let out = {}

                this.questions.forEach(item => {
                    out[item.id] = item
                })

                return out
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .question {
        &__title {}
        &__desc {
            color #777777
        }
    }

    .table-skills {
        width 100%
        border-collapse collapse

        &__header {
            text-align center
        }

        td {
            padding .5rem 1rem
            border 1px solid rgba(0,0,0,0.42)
        }
    }
</style>